export default "__VITE_ASSET__4ffb2cea__"